import { EditorPlugin, IEditor, PluginEvent, PluginEventType } from 'roosterjs-editor-types';
import { fromHtml } from 'roosterjs-editor-dom';

const OWA_REFERENCE_ATTACHMENT_SELECTOR = '#OwaReferenceAttachments';
const OWA_REFERENCE_ATTACHMENT_END_SELECTOR = '#OwaReferenceAttachmentsEnd';

export default class ReferenceAttachmentPlugin implements EditorPlugin {
    private editor: IEditor | null = null;
    private hiddenAttachmentsHtml: string = '';

    initialize(editor: IEditor) {
        this.editor = editor;
    }

    dispose() {
        this.editor = null;
    }

    getName() {
        return 'ReferenceAttachment';
    }

    onPluginEvent(event: PluginEvent) {
        if (event.eventType === PluginEventType.EditorReady && this.editor) {
            // If the editor body contains hidden attachment helper nodes, temporarily remove them,
            // and we will add them back when retrieve the HTML content.
            const divOwaReferenceAttachments = this.editor.queryElements(
                OWA_REFERENCE_ATTACHMENT_SELECTOR
            )[0];
            const divOwaReferenceAttachmentsEnd = this.editor.queryElements(
                OWA_REFERENCE_ATTACHMENT_END_SELECTOR
            )[0];

            if (
                divOwaReferenceAttachments &&
                !divOwaReferenceAttachments.previousElementSibling &&
                divOwaReferenceAttachmentsEnd &&
                divOwaReferenceAttachmentsEnd.previousElementSibling == divOwaReferenceAttachments
            ) {
                this.hiddenAttachmentsHtml =
                    (divOwaReferenceAttachments ? divOwaReferenceAttachments.outerHTML : '') +
                    (divOwaReferenceAttachmentsEnd ? divOwaReferenceAttachmentsEnd.outerHTML : '');
                this.editor.deleteNode(divOwaReferenceAttachments);
                this.editor.deleteNode(divOwaReferenceAttachmentsEnd);
            }
        } else if (event.eventType === PluginEventType.ExtractContentWithDom) {
            // Add the attachment helper nodes back
            const nodes = fromHtml(this.hiddenAttachmentsHtml, event.clonedRoot.ownerDocument);
            for (let i = nodes.length - 1; i >= 0; i--) {
                event.clonedRoot.insertBefore(nodes[i], event.clonedRoot.firstChild);
            }
        }
    }
}
